import React from "react";
import axios from "axios";
import "../auth.css";
import "../list.css";
import "../react-datetim.css";
import { Button } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { reactLocalStorage } from "reactjs-localstorage";
import Select from "react-select";
import i18n from "../i18n";
import { connect } from "react-redux";
import Menutest from "./menu.js";
import Modal from "react-modal";
import { Grid, Segment, Accordion, Pagination } from "semantic-ui-react";
import { Icon, List, Table, Checkbox } from "semantic-ui-react";
import { SemanticToastContainer, toast } from "react-semantic-toasts";
import "react-semantic-toasts/styles/react-semantic-alert.css";
import Confetti from "react-confetti";
import DateTime from "react-datetime";
import { API_BASE_URL } from "../utils/endpoints";

import PhoneInput from 'react-phone-input-2';

var back='';
var mobile = [];
var groupOptions = [];
var value_variables;
var value_variables_one;
var categoryOptions = [];
var categoryGroupOptions = [];
var array_data = [];
var category_ids = [];
var template = [];
var count =1;
var data = new FormData();

const customStyles = {
  content: {
    left: "13%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%"
  }
};
const customStylesstop = {
  content: {
    width: "40%",
    marginRight: "30%",
    marginLeft: "30%",
    height: "231px",
    marginTop: "6%",
    background: " #fcfcfc !important",
    overflow: "auto"
  }
};

var countryOptions = [];
var yesterday = DateTime.moment().subtract( 1, 'day' );
var valid = function( current ){
    return current.isAfter( yesterday );
};

class BulkSMS extends React.Component {
  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;

    this.setState({ activeIndex: newIndex });
  };

  constructor(props) {
    super(props);
    this.state = {
      title: "",
      products: [
        { label: i18n.t("Number.label"), value: "single_numbers" },
        { label: i18n.t("File.label"), value: "file" },
        { label: i18n.t("Contact_List.label"), value: "single_numbers" },
        { label: i18n.t("Dynamic_File.label"), value: "dynamic_file" },
        { label: i18n.t("Group.label"), value: "group" },
        { label: i18n.t("Category.label"), value: "group" },
      
      
      ],
      typeofMSg: "",
      nameoftype: "",
      typeofvariable: "",
      nameofvariable: "",
      uploadfile: [],
      contactselect: [],
      senderidoption: [],
      senderid: [],
      length_category:0,
      time: [
        { label: i18n.t("Send_Now.label"), value: 1 },
        { label: i18n.t("Schedule_time.label"), value: 2 }
      ],
      timeselect: [{ label: i18n.t("Send_Now.label"), value: 1 }],
      timeofsend: "",
      dateofsend: "",
      content: "",
      senderidselect: "",
      callbackDataValid: [{}],
      callbackDataInValid: [],
      modalIsOpen: false,
      modalIsOpenContact: false,
      show: false,
      collapsed: false,
      collapseID: "",
      confirm: "",
      resultall: "",
      resultallinvalid: "",
      persons: [],
      totalpage: "1",
      activePage: 1,
      personssearch: [],
      totalmsg: "",
      contactArray: [],
      options_sender: [],
      groups_id: [],
      add_numbers: [],
      remove_numbers: [],
      groups: [],
      options_senders: [],
      items: [],
      focused: false,
      input: "",
      items2: [],
      input2: "",
      variables: [
        { label: "first_name", value: "first_name" },
        { label: "second_name", value: "second_name" },
        { label: "family_name", value: "family_name" },
        { label: "company", value: "company" },
        { label: "country", value: "country" },
        { label: "governerate", value: "governerate" },
        { label: "district", value: "district" },
        { label: "area", value: "area" },
        { label: "mobile_number", value: "mobile_number" },
        { label: "createdTime", value: "createdTime" },
        { label: "custom_filter1", value: "custom_filter1" },
        { label: "custom_filter2", value: "custom_filter2" },
        { label: "custom_filter3", value: "custom_filter3" },
        { label: "custom_filter4", value: "custom_filter4" },
        { label: "custom_filter5", value: "custom_filter5" },
        { label: "custom_filter6", value: "custom_filter6" }
      ],
      lenght_msg: "",
      date: new Date(),
      send_now: true,
      options_sender_category: [],
      isArabic: false,
      balance_reserved: {},
      modalIsOpenScheule:false,
      file: null,
      inputKey: Date.now()
    };
    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.openModalSchedule = this.openModalSchedule.bind(this);
    this.afterOpenModalSchedule = this.afterOpenModalSchedule.bind(this);
    this.closeModalSchedule = this.closeModalSchedule.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputKeyDown = this.handleInputKeyDown.bind(this);
    this.handleRemoveItem = this.handleRemoveItem.bind(this);
    this.handleInputChange2 = this.handleInputChange2.bind(this);
    this.handleInputKeyDown2 = this.handleInputKeyDown2.bind(this);
    this.handleRemoveItem2 = this.handleRemoveItem2.bind(this);

  }
  onChangedatetime = date => {
    date = new Date(date);
    this.setState({ date });
  };

  openModal() {
    this.setState({ modalIsOpen: true });
  }

  afterOpenModal() {
    this.subtitle.style.color = "#f00";
  }

  openModalSchedule() {
    this.setState({ modalIsOpenScheule: true });
  }

  afterOpenModalSchedule() {
    this.subtitle.style.color = "#f00";
  }

  closeModal() {
    this.setState({ modalIsOpen: false });
    this.setState({title:"",typeofMSg:"",content:"",send_now:true,senderidselect:"",groups_id:[],items:[],items2:[]});
    data.delete("file");
    data.delete("object");
    window.location="bulk";
  }


  afterOpenModalContact() {}

  closeModalSchedule() {
    this.setState({ modalIsOpenScheule: false });
    window.location="ReportBulk";
  }
 
  componentWillMount() {
    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/senderid/getSenderIds";
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/senderid/getSenderIds";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then(res => {
      if (res.data.result.sender_ids != undefined) {
        const senderidoption = res.data.result.sender_ids;
        var length = res.data.result.sender_ids.length;
        var i;
        const newArr = this.state.options_sender;
        for (i = 0; i < length; i++) {
          var value_option = senderidoption[i].sender_id;

          newArr.push({
            label: value_option,
            value: senderidoption[i].id
          });
        }
        this.setState({ options_sender: res.data.result.sender_ids });

        countryOptions = newArr;
      }
    });
    var token = reactLocalStorage.get("accessToken");
    reactLocalStorage.get("user_id_login");
    var page_num = this.state.activePage - 1;

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/contacts/user=" +
        reactLocalStorage.get("user_id_login") +
        "/page=" +
        page_num +
        "/findallcontacts";
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/contacts/user=" +
        reactLocalStorage.get("user_id_login") +
        "/page=" +
        page_num +
        "/findallcontacts";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then(res => {
      const persons = res.data.result.contacts;
      var totalContactspages = Math.ceil(res.data.result.total_contacts / 20);
      this.setState({ totalpage: totalContactspages });
      if (res.data.result.contacts != undefined) {
        this.setState({ persons });
      }
    });

    // get groups id
    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/contacts/getGroups";
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/contacts/getGroups";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then(res => {
      if (res.data != undefined && res.data.result.groups != undefined) {
        const dataoption = res.data.result.groups;
        var length = res.data.result.groups.length;
        var i;
        const newArr = this.state.options_senders;
        for (i = 0; i < length; i++) {
          var value_option = dataoption[i].group_name;

          newArr.push({
            label: value_option,
            value: dataoption[i].id
          });
        }
        groupOptions = newArr;
      }
    });

    // to get categories
    var token = reactLocalStorage.get("accessToken");

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/contacts/" +
        reactLocalStorage.get("user_id_login") +
        "/findAllCategories";
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/contacts/" +
        reactLocalStorage.get("user_id_login") +
        "/findAllCategories";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then(res => {
      const persons = res.data.result.Categories;
      var i;
      var newArr = [];
      if (persons != undefined) {
        for (i = 0; i < res.data.result.Categories.length; i++) {
          var value_option = res.data.result.Categories[i].category_name;

          newArr.push({
            label: value_option,
            value: res.data.result.Categories[i].id
          });
        }
        categoryOptions = newArr;
      }
    });

    // to get templates
    var token = reactLocalStorage.get("accessToken");

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var page_num = -1;
    var search = "";
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/corpsms/gettemplate?page=" +
        page_num +
        "&filter=" +
        search;
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/corpsms/gettemplate?page=" +
        page_num +
        "&filter=" +
        search;
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then(res => {
      if (res.data.result != undefined) {
        var i;

        var i;
        const newArr = [];
        for (i = 0; i < res.data.result.templates.length; i++) {
          var value_option = res.data.result.templates[i].template_name;

          newArr.push({
            label: value_option,
            value: res.data.result.templates[i].template_value
          });
        }

        template = newArr;
      }
    });
  }

  searchchangeAdd = event => {
    if (event.target.value != "") {
      document.querySelector(".view_basic").style = "display:none";
      document.querySelector(".view_search").style = "display:block";
      var token = reactLocalStorage.get("accessToken");

      reactLocalStorage.get("user_id_login");

      var ip = API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      if (ip.includes(s2)) {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/contacts/" +
          reactLocalStorage.get("user_id_login") +
          "/" +
          event.target.value +
          "/searchContacts";
      } else {
        apiBaseUrl =
          API_BASE_URL +
          "/core/user/rest/contacts/" +
          reactLocalStorage.get("user_id_login") +
          "/" +
          event.target.value +
          "/searchContacts";
      }

      var headers = { "Content-Type": "application/json", token: token };
      axios.get(apiBaseUrl, { headers: headers }).then(res => {
        if (res.data.result.contacts != undefined) {
          const personssearch = res.data.result.contacts;
          this.setState({ totalpage: res.data.result.total_contacts });

          this.setState({ personssearch });
        }
      });
    } else {
      document.querySelector(".view_basic").style = "display:block";
      document.querySelector(".view_search").style = "display:none";
    }
  };
  handleChangeTitle = event => {
    document.querySelector('.title_data').style='border-color:#ced4da';
    this.setState({ title: event.target.value }, function() {});
  };

  handleChangeContent = event => {
    document.querySelector('.textarea_content').style='border-color:#ced4da';
    this.setState({ content: event.target.value });

    if(event.target.value.includes('var_')) 
    {
     count=event.target.value.split("var_").length - 1;

    }

    var ltrChars =
        "A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02B8\u0300-\u0590\u0800-\u1FFF" +
        "\u2C00-\uFB1C\uFDFE-\uFE6F\uFEFD-\uFFFF",
      rtlChars = "\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC",
      rtlDirCheck = new RegExp("^[^" + ltrChars + "]*[" + rtlChars + "]");

    if (rtlDirCheck.test(event.target.value) === true) {
      document.querySelector(".textarea__countar").style = "display:block";
      document.querySelector(".textarea__countar").style = "float:right";
      document.querySelector(".textarea__counten").style = "display:none";
    } else {
      document.querySelector(".textarea__countar").style = "display:none";
      document.querySelector(".textarea__counten").style = "display:block";
      document.querySelector(".textarea__counten").style = "float:right";
    }
  };
  handleChangeupload = event => {
   /* const newArr = this.state.file;

    if (newArr.length > 0) {
      this.setState({ uploadfile: [] });
      data.delete("file")
    }
    newArr.push(event.target.files[0]);
    this.setState({
      uploadfile: newArr
    });*/

    data.set("file", event.target.files[0]);
  };

  onChangevariables = values => {
    this.setState({ typeofvariable: values.value }, function() {});
    this.setState({ nameofvariable: values.label }, function() {});
    value_variables = this.state.content + " " + "{" + values.value + "}";
    this.setState({ content: value_variables });
  };

  onChange = values => {
    this.setState({ typeofMSg: values.value });
    this.setState({ nameoftype: values.label });

    if (values.label === "Number" || values.label === "رقم") {
      document.querySelector(".mobile_div").style = "display:block";
    } else {
      document.querySelector(".mobile_div").style = "display:none";
    }

    if (
      values.label === "File" ||
      values.label === "Dynamic File" ||
      values.label === "ملف" ||
      values.label === "ملف متغير" || values.label === "Smart dynamic" ||
      values.label ===  "ديناميكية ذكية"
         
    ) {
      document.querySelector(".upload_div").style = "display:block";
    } else {
      document.querySelector(".upload_div").style = "display:none";
    }
    if (values.label === "Group" || values.label === "مجموعة") {
      document.querySelector(".group_div").style = "display:block";
      document.querySelector(".drop_variables").style = "display:block";
    } else {
      document.querySelector(".group_div").style = "display:none";
    }

    if (values.label === "Category" || values.label === "فئة") {
      document.querySelector(".category_div").style = "display:block";
      document.querySelector(".drop_variables").style = "display:block";
    } else {
      document.querySelector(".category_div").style = "display:none";
    }

    if (values.label === "Contact List" || values.label === "قائمة الاتصال") {
      document.querySelector(".contact_list_div").style = "display:block";
      this.setState({ modalIsOpenContact: true });
    } else {
      document.querySelector(".contact_list_div").style = "display:none";
      this.setState({ modalIsOpenContact: false });
    }

    if(values.label === "Smart dynamic" || values.label ===  "ديناميكية ذكية")
    {
      document.querySelector(".add_variable_btn").style = "display:block";
      document.querySelector(".textarea__counten_varaibles").style = "display:block";
      
    }
    else
    {
      document.querySelector(".add_variable_btn").style = "display:none";
      document.querySelector(".textarea__counten_varaibles").style = "display:none";
    }
  };

  onChangecontact(values) {
    this.setState({
      contactselect: values
    });
  }
  onChangetime(values) {
    this.setState({
      timeselect: values
    });
    if (values.label === "Schedule time" || values.label === "ضبط الوقت") {
      document.querySelector(".time_div").style = "display:block";
      this.setState({ send_now: false });
    } else {
      document.querySelector(".time_div").style = "display:none";
      this.setState({ send_now: true });
    }
  }

  onchangescheduledate = event => {
    this.setState({
      dateofsend: event.target.value
    });
  };
  onchangeschedule = event => {
    this.setState({
      timeofsend: event.target.value
    });
  };
  onChangesenderid = event => {
    this.setState({ senderidselect: event.label }, function() {});
  };
  openstep2 = () => {
    if(this.state.title === "") {
      document.querySelector('.title_data').style='border-color:red';
    toast({
      type: "error",
      title: i18n.t("error.label"),
      description: i18n.t("Please_fill_title_field.label"),
      animation: "bounce",
      time: 5000
    });
  }
  if(this.state.nameoftype === "")
  {
    document.querySelector('.select_data').style='border-color:red';
  toast({
    type: "error",
    title: i18n.t("error.label"),
    description: i18n.t("Pleaseselect_option.label"),
    animation: "bounce",
    time: 5000
  });
  }
    if (this.state.nameoftype === "Number" || this.state.nameoftype === "رقم") {
      if (this.state.mobile != undefined && this.state.title != "" && this.state.mobile.length > 0) {
        document.querySelector(".bulk_add_card").style = "display:none";
        document.querySelector(".step_two").style = "display:block";
        var lang = i18n.language;
        if (lang === "ar") {
          document.querySelector(".step_two").style = "text-align: right;";
        }
      }


     else if(this.state.mobile == undefined || this.state.mobile.length === 0)
     {
       document.querySelector('.react-tel-input input[type=tel]').style='border-color:red';
       
     toast({
       type: "error",
       title: i18n.t("error.label"),
       description: i18n.t("Please_enter_mobile_number.label"),
       animation: "bounce",
       time: 5000
     });
     }
else
{
  document.querySelector('.title_data').style='border-color:red';
  document.querySelector('.react-tel-input input[type=tel]').style='border-color:red';
toast({
  type: "error",
  title: i18n.t("error.label"),
  description: i18n.t("Please_fill_all_fields.label"),
  animation: "bounce",
  time: 5000
});
}  

    }
    if(this.state.nameoftype == "File" || this.state.nameoftype === "Dynamic File" || this.state.nameoftype === "ملف" || this.state.nameoftype === "ملف  متغير"
     || this.state.nameoftype === "Smart dynamic" || this.state.nameoftype === "ديناميكية ذكية")
    { 
      if(!data.get('file'))
      {
        document.querySelector('.input_file').style='border-color:red';
        toast({
          type: "error",
          title: i18n.t("error.label"),
          description: i18n.t("Pleasechoose_file.label"),
          animation: "bounce",
          time: 5000
        });
      }
      
    }
    if(this.state.nameoftype === "Group" || this.state.nameoftype === "مجموعة")
    {
      console.log(this.state.groups_id.length)
      if(this.state.groups_id.length == 0)
      {
        
        document.querySelector('.group_input').style='border-color:red';
      toast({
        type: "error",
        title: i18n.t("error.label"),
        description: i18n.t("Pleasechoose_group.label"),
        animation: "bounce",
        time: 5000
      });
      }
      else if(this.state.groups_id.length > 0)
      {
        document.querySelector(".bulk_add_card").style = "display:none";
        document.querySelector(".step_two").style = "display:block";
      }
      
  
    }
    if(this.state.nameoftype === "Category" || this.state.nameoftype === "فئة")
    {
      if(this.state.length_category === 0)
      {
          document.querySelector('.category_input').style='border-color:red';
      toast({
        type: "error",
        title: i18n.t("error.label"),
        description: i18n.t("Pleasechoose_category.label"),
        animation: "bounce",
        time: 5000
      });
  
      }
      else if(this.state.length_category > 0)
      {
        document.querySelector(".bulk_add_card").style = "display:none";
        document.querySelector(".step_two").style = "display:block";
      }
    
    }
    if (this.state.nameoftype === "Contact List" || this.state.nameoftype === "قائمة الاتصال")
    {
      if(mobile.length == 0)
      {
        toast({
          type: "error",
          title: i18n.t("error.label"),
          description: i18n.t("Pleasechoose_contact.label"),
          animation: "bounce",
          time: 5000
        });
      }
      else if(mobile.length >0)
      {
        document.querySelector(".bulk_add_card").style = "display:none";
  document.querySelector(".step_two").style = "display:block";
      }

    }
if(this.state.nameoftype != "Number"  &&  this.state.title != "" && this.state.nameoftype != "" && data.get('file'))
{
  document.querySelector(".bulk_add_card").style = "display:none";
  document.querySelector(".step_two").style = "display:block";
}
  };
  openstep1 = () => {
    document.querySelector(".bulk_add_card").style = "display:block";
    document.querySelector(".step_two").style = "display:none";
    document.querySelector(".upload_div").style = "display:none";
    document.querySelector(".group_div").style = "display:none";
    document.querySelector(".category_div").style = "display:none";
    document.querySelector(".mobile_div").style = "display:none";
    
    document.querySelector('.title_data').style='border-color:#ced4da';
    document.querySelector('.react-tel-input input[type=tel]').style='border-color:#ced4da';
    document.querySelector('.select_data').style='border-color:#ced4da';
    document.querySelector('.input_file').style='border-color:#ced4da';
    document.querySelector('.group_input').style='border-color:#ced4da';
    document.querySelector('.category_input').style='border-color:#ced4da';
    this.setState({ title: "" }, function() {});

    this.setState({ typeofMSg: "" });
    this.setState({ mobile: "" });
    mobile = [];
    reactLocalStorage.set("mobile", mobile);
    this.setState({ nameoftype: "" });
    this.setState({ uploadfile: [] });
    this.setState({ groups_id: [] });
   

    data.delete("object");
    data.delete("file");
    this.setState({
      file: null,
      groups_id:[],
      length_category:0,
      inputKey: Date.now()
    });
    this.setState({ nameoftype: "" }, function() {});
  };
  openstep3 = () => {
    if (this.state.senderidselect != "") {
      document.querySelector(".step_three").style = "display:block";
      document.querySelector(".step_two").style = "display:none";
    } else {
      toast({
        type: "error",
        title: i18n.t("error.label"),
        description: i18n.t("Please_fill_all_fields.label"),
        animation: "bounce",
        time: 5000
      });
    }
    if (this.state.typeofMSg === "dynamic_file") {
      document.querySelectorAll(".templates-class").style =
        "display:none !important";
    }
    var lang = i18n.language;
    if (lang === "ar") {
      document.querySelector(".step_three").style = "text-align: right;";
    }

  };
  openstep22 = () => {
    if(back == 'true')
    {
      document.querySelector(".bulk_add_card").style = "display:block";
      document.querySelector(".step_two").style = "display:none";
      document.querySelector(".step_three").style = "display:none";
      document.querySelector(".upload_div").style = "display:none";
      this.setState({ senderidselect: "" });
      data.delete("object");
      data.delete("file");
      this.setState({
        file: null,
        inputKey: Date.now()
      });
    this.setState({ title: "" }, function() {});

    this.setState({ typeofMSg: "" });
    this.setState({ mobile: "" });
    mobile = [];
    reactLocalStorage.set("mobile", mobile);
    this.setState({ nameoftype: "" });
    this.setState({ uploadfile:null});
    document.getElementById("btn_submit_step3").disabled = false;
    }
    else
    {
    document.querySelector(".bulk_add_card").style = "display:none";
    document.querySelector(".step_two").style = "display:block";
    document.querySelector(".step_three").style = "display:none";
    document.getElementById("btn_submit_step3").disabled = false;
    this.setState({ senderidselect: "" });
    data.delete("object");
    data.delete("file");
    }
   
  };
  submit = event => {
    event.preventDefault();
    if(this.state.send_now === false)
    {
      var defaultDate=new Date();
      if(this.state.date >= defaultDate)
      {
        if(this.state.content === "" && this.state.typeofMSg !== "dynamic_file")
    {
      document.querySelector('.textarea_content').style='border-color:red';
      toast({
        type: "error",
        title: i18n.t("error.label"),
        description: i18n.t("Please_fill_content_fields.label"),
        animation: "bounce",
        time: 5000
      });
    }
    else if (this.state.content != "" || this.state.typeofMSg === "dynamic_file") {
      let currentComponent = this;
      document.getElementById("btn_submit_step3").disabled = true;
      document.getElementById("btn_back_step3").disabled = true;
      var i;
      var array = [];
      for (i = 0; i < category_ids.length; i++) {
        array.push(category_ids[i].value);
      }
      var token = reactLocalStorage.get("accessToken");
      if (
        this.state.nameoftype === "Number" ||
        this.state.nameoftype === "رقم"
      ) {
        mobile = [];
        mobile.push(reactLocalStorage.get("mobile"));
      }

      if (
        this.state.nameoftype === "Contact List" ||
        this.state.nameoftype === "قائمة الاتصال"
      ) {
        mobile = mobile;
      }
      
      var d = this.state.date;
      var month = d.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      var hour = d.getHours();
      if (hour < 10) {
        hour = "0" + hour;
      }
      var date = d.getDate();
      if (date < 10) {
        date = "0" + date;
      }
      var minutes = d.getMinutes();
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      var dformat =
        [d.getFullYear(), month, date].join("-") +
        "T" +
        [hour, minutes, d.getSeconds() + "0"].join(":") +
        "Z";

      var date_time = dformat;
      var groups_id = this.state.groups_id;
      var i;
      var array2 = [];
      for (i = 0; i < this.state.groups_id.length; i++) {
        array2.push(groups_id[i].value);
      }
      if (
        this.state.nameoftype === "Group" ||
        (this.state.nameoftype === "مجموعة" && this.state.send_now === false)
      ) {
        var test = new Blob(
          [
            JSON.stringify({
              recipient_numbers_type: this.state.typeofMSg,
              content: this.state.content,
              service_type: "bulk_sms",
              send_now: this.state.send_now,
              sender_id: this.state.senderidselect,
              groups_id: array2,
              add_numbers: this.state.items,
              remove_numbers: this.state.items2,
              schedule_date: date_time,
              title: this.state.title
            })
          ],
          { type: "application/json" }
        );
        data.append("object", test);
      } else if (
        this.state.nameoftype === "Group" ||
        (this.state.nameoftype === "مجموعة" && this.state.send_now === true)
      ) {
        var test = new Blob(
          [
            JSON.stringify({
              recipient_numbers_type: this.state.typeofMSg,
              content: this.state.content,
              service_type: "bulk_sms",
              send_now: this.state.send_now,
              sender_id: this.state.senderidselect,
              groups_id: array2,
              add_numbers: this.state.items,
              remove_numbers: this.state.items2,
              title: this.state.title
            })
          ],
          { type: "application/json" }
        );
        data.append("object", test);
      } else if (
        this.state.nameoftype === "Category" ||
        (this.state.nameoftype === "فئة" && this.state.send_now === true)
      ) {
        var test = new Blob(
          [
            JSON.stringify({
              recipient_numbers_type: this.state.typeofMSg,
              content: this.state.content,
              service_type: "bulk_sms",
              send_now: this.state.send_now,
              sender_id: this.state.senderidselect,
              groups_id: array,
              add_numbers: this.state.items,
              remove_numbers: this.state.items2,
              title: this.state.title
            })
          ],
          { type: "application/json" }
        );
        data.append("object", test);
      } else if (
        this.state.nameoftype === "Category" ||
        (this.state.nameoftype === "فئة" && this.state.send_now === false)
      ) {
        var test = new Blob(
          [
            JSON.stringify({
              recipient_numbers_type: this.state.typeofMSg,
              content: this.state.content,
              service_type: "bulk_sms",
              send_now: this.state.send_now,
              sender_id: this.state.senderidselect,
              groups_id: array,
              add_numbers: this.state.items,
              remove_numbers: this.state.items2,
              schedule_date: date_time,
              title: this.state.title
            })
          ],
          { type: "application/json" }
        );
        data.append("object", test);
      } else if (this.state.send_now === false) {
        var test = new Blob(
          [
            JSON.stringify({
              recipient_numbers_type: this.state.typeofMSg,
              content: this.state.content,
              service_type: "bulk_sms",
              send_now: this.state.send_now,
              sender_id: this.state.senderidselect,
              phone_numbers: mobile,
              schedule_date: date_time,
              title: this.state.title
            })
          ],
          { type: "application/json" }
        );
        data.append("object", test);
      } else if (this.state.send_now === true) {
        var test = new Blob(
          [
            JSON.stringify({
              recipient_numbers_type: this.state.typeofMSg,
              content: this.state.content,
              service_type: "bulk_sms",
              send_now: this.state.send_now,
              sender_id: this.state.senderidselect,
              phone_numbers: mobile,
              title: this.state.title
            })
          ],
          { type: "application/json" }
        );
        data.append("object", test);
      }

      var ip = API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      if (ip.includes(s2)) {
        apiBaseUrl = API_BASE_URL + "/core/corpsms/sendBulk";
      } else {
        apiBaseUrl = API_BASE_URL + "/core/corpsms/sendBulk";
      }

      axios
        .post(apiBaseUrl, data, {
          headers: { "Content-Type": "multipart/form-data", token: token }
        })
        .then(function(response) {
          if (response.status === 200) {
            var result = response.data.result;


            if (
              result != undefined &&
              response.data.status == "send confirm!"
            ) {
              currentComponent.setState({
                resultall: response.data.result.valid_numbers_count
              });
              currentComponent.setState({
                resultallinvalid: response.data.result.invalid_numbers_count
              });
              currentComponent.setState({
                callbackDataValid: response.data.result.valid_numbers
              });
              currentComponent.setState({
                totalmsg: response.data.result.total_messages
              });
              currentComponent.setState({
                balance_reserved: response.data.result.balance_reserved.bulk_sms
              });

              
              currentComponent.setState({
                callbackDataInValid: response.data.result.invalid_numbers
              });

              currentComponent.setState({ modalIsOpen: true });
              currentComponent.setState({ confirm: result.confirm_id });
            }
            else {
              toast({
                type: "warning",
                title: i18n.t("warning.label"),
                description: response.data.status,
                animation: "bounce",
                time: 5000
              });
              document.getElementById("btn_back_step3").disabled = false;
            }
            data.delete("file");
            data.delete("object");
            
            back='true';

          } else if (response.status === 204) {
            console.log("Something wrong");
            toast({
              type: 'error',
              title: i18n.t('error.label'),
              description:i18n.t('Something_wrong.label'),
              animation: 'bounce',
              time: 5000,
  
          });
          document.getElementById("btn_back_step3").disabled = false;
          } 
        })
        .catch(function(error) {
          console.log(error);
          toast({
            type: 'error',
            title: i18n.t('error.label'),
            description:i18n.t('Something_wrong.label'),
            animation: 'bounce',
            time: 5000,

        });
        document.getElementById("btn_back_step3").disabled = false;
        });
    } else {
      toast({
        type: "error",
        title: i18n.t("error.label"),
        description: i18n.t("Please_fill_all_fields.label"),
        animation: "bounce",
        time: 5000
      });
    }
      }
      else
      {
        toast({
          type: "error",
          title: i18n.t("error.label"),
          description: i18n.t("Please_choose_avalid_time.label"),
          animation: "bounce",
          time: 5000
        });
           }
    }
    else
    {
      if(this.state.content === "" && this.state.typeofMSg !== "dynamic_file")
      {
        document.querySelector('.textarea_content').style='border-color:red';
        toast({
          type: "error",
          title: i18n.t("error.label"),
          description: i18n.t("Please_fill_content_fields.label"),
          animation: "bounce",
          time: 5000
        });
      }
      else if (this.state.content != "" || this.state.typeofMSg === "dynamic_file") {
        let currentComponent = this;
        document.getElementById("btn_submit_step3").disabled = true;
        document.getElementById("btn_back_step3").disabled = true;
        var i;
        var array = [];
        for (i = 0; i < category_ids.length; i++) {
          array.push(category_ids[i].value);
        }
        var token = reactLocalStorage.get("accessToken");
        if (
          this.state.nameoftype === "Number" ||
          this.state.nameoftype === "رقم"
        ) {
          mobile = [];
          mobile.push(reactLocalStorage.get("mobile"));
        }
  
        if (
          this.state.nameoftype === "Contact List" ||
          this.state.nameoftype === "قائمة الاتصال"
        ) {
          mobile = mobile;
        }
        
        var d = this.state.date;
        var month = d.getMonth() + 1;
        if (month < 10) {
          month = "0" + month;
        }
        var hour = d.getHours();
        if (hour < 10) {
          hour = "0" + hour;
        }
        var date = d.getDate();
        if (date < 10) {
          date = "0" + date;
        }
        var minutes = d.getMinutes();
        if (minutes < 10) {
          minutes = "0" + minutes;
        }
        var dformat =
          [d.getFullYear(), month, date].join("-") +
          "T" +
          [hour, minutes, d.getSeconds() + "0"].join(":") +
          "Z";
  
        var date_time = dformat;
        var groups_id = this.state.groups_id;
        var i;
        var array2 = [];
        for (i = 0; i < this.state.groups_id.length; i++) {
          array2.push(groups_id[i].value);
        }
        if (
          this.state.nameoftype === "Group" ||
          (this.state.nameoftype === "مجموعة" && this.state.send_now === false)
        ) {
          var test = new Blob(
            [
              JSON.stringify({
                recipient_numbers_type: this.state.typeofMSg,
                content: this.state.content,
                service_type: "bulk_sms",
                send_now: this.state.send_now,
                sender_id: this.state.senderidselect,
                groups_id: array2,
                add_numbers: this.state.items,
                remove_numbers: this.state.items2,
                schedule_date: date_time,
                title: this.state.title
              })
            ],
            { type: "application/json" }
          );
          data.append("object", test);
        } else if (
          this.state.nameoftype === "Group" ||
          (this.state.nameoftype === "مجموعة" && this.state.send_now === true)
        ) {
          var test = new Blob(
            [
              JSON.stringify({
                recipient_numbers_type: this.state.typeofMSg,
                content: this.state.content,
                service_type: "bulk_sms",
                send_now: this.state.send_now,
                sender_id: this.state.senderidselect,
                groups_id: array2,
                add_numbers: this.state.items,
                remove_numbers: this.state.items2,
                title: this.state.title
              })
            ],
            { type: "application/json" }
          );
          data.append("object", test);
        } else if (
          this.state.nameoftype === "Category" ||
          (this.state.nameoftype === "فئة" && this.state.send_now === true)
        ) {
          var test = new Blob(
            [
              JSON.stringify({
                recipient_numbers_type: this.state.typeofMSg,
                content: this.state.content,
                service_type: "bulk_sms",
                send_now: this.state.send_now,
                sender_id: this.state.senderidselect,
                groups_id: array,
                add_numbers: this.state.items,
                remove_numbers: this.state.items2,
                title: this.state.title
              })
            ],
            { type: "application/json" }
          );
          data.append("object", test);
        } else if (
          this.state.nameoftype === "Category" ||
          (this.state.nameoftype === "فئة" && this.state.send_now === false)
        ) {
          var test = new Blob(
            [
              JSON.stringify({
                recipient_numbers_type: this.state.typeofMSg,
                content: this.state.content,
                service_type: "bulk_sms",
                send_now: this.state.send_now,
                sender_id: this.state.senderidselect,
                groups_id: array,
                add_numbers: this.state.items,
                remove_numbers: this.state.items2,
                schedule_date: date_time,
                title: this.state.title
              })
            ],
            { type: "application/json" }
          );
          data.append("object", test);
        } else if (this.state.send_now === false) {
          var test = new Blob(
            [
              JSON.stringify({
                recipient_numbers_type: this.state.typeofMSg,
                content: this.state.content,
                service_type: "bulk_sms",
                send_now: this.state.send_now,
                sender_id: this.state.senderidselect,
                phone_numbers: mobile,
                schedule_date: date_time,
                title: this.state.title
              })
            ],
            { type: "application/json" }
          );
          data.append("object", test);
        } else if (this.state.send_now === true) {
          var test = new Blob(
            [
              JSON.stringify({
                recipient_numbers_type: this.state.typeofMSg,
                content: this.state.content,
                service_type: "bulk_sms",
                send_now: this.state.send_now,
                sender_id: this.state.senderidselect,
                phone_numbers: mobile,
                title: this.state.title
              })
            ],
            { type: "application/json" }
          );
          data.append("object", test);
        }
  
        var ip = API_BASE_URL;
        var s2 = "localhost:3000";
        var apiBaseUrl;
        if (ip.includes(s2)) {
          apiBaseUrl = API_BASE_URL + "/core/corpsms/sendBulk";
        } else {
          apiBaseUrl = API_BASE_URL + "/core/corpsms/sendBulk";
        }
  
        axios
          .post(apiBaseUrl, data, {
            headers: { "Content-Type": "multipart/form-data", token: token }
          })
          .then(function(response) {
            if (response.status === 200) {
              var result = response.data.result;
  
  
              if (
                result != undefined &&
                response.data.status == "send confirm!"
              ) {
                currentComponent.setState({
                  resultall: response.data.result.valid_numbers_count
                });
                currentComponent.setState({
                  resultallinvalid: response.data.result.invalid_numbers_count
                });
                currentComponent.setState({
                  callbackDataValid: response.data.result.valid_numbers
                });
                currentComponent.setState({
                  totalmsg: response.data.result.total_messages
                });
                currentComponent.setState({
                  balance_reserved: response.data.result.balance_reserved.bulk_sms
                });
                currentComponent.setState({
                  callbackDataInValid: response.data.result.invalid_numbers
                });
  
                currentComponent.setState({ modalIsOpen: true });
                currentComponent.setState({ confirm: result.confirm_id });
              }
              else {
                toast({
                  type: "warning",
                  title: i18n.t("warning.label"),
                  description: response.data.status,
                  animation: "bounce",
                  time: 5000
                });
                document.getElementById("btn_back_step3").disabled = false;
              }
              data.delete("file");
              data.delete("object");
              
              back='true';
  
            } else if (response.status === 204) {
              console.log("Something wrong");
              toast({
                type: 'error',
                title: i18n.t('error.label'),
                description:i18n.t('Something_wrong.label'),
                animation: 'bounce',
                time: 5000,
    
            });
            document.getElementById("btn_back_step3").disabled = false;
            } 
          })
          .catch(function(error) {
            console.log(error);
            toast({
              type: 'error',
              title: i18n.t('error.label'),
              description:i18n.t('Something_wrong.label'),
              animation: 'bounce',
              time: 5000,
  
          });
          document.getElementById("btn_back_step3").disabled = false;
          });
      } else {
        toast({
          type: "error",
          title: i18n.t("error.label"),
          description: i18n.t("Please_fill_all_fields.label"),
          animation: "bounce",
          time: 5000
        });
      }
    }
    
  };

  closemodalcontact = () => {
    this.setState({ modalIsOpenContact: false });

  };
  confirm_msg = (event) => {
    event.preventDefault();
    document.getElementById("confirm_sms").disabled = true;
    let currentComponent = this;
    var token = reactLocalStorage.get("accessToken");
    var confirm = this.state.confirm;

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/jobs/saveBulk/" + confirm;
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/jobs/saveBulk/" + confirm;
    }

    var data = {};
    axios
      .post(apiBaseUrl, data, {
        headers: { "Content-Type": "application/json", token: token }
      })
      .then(function(response) {
        if (response.status === 200) {
          if (response.data.result != undefined) {
            if (response.data.status === "saved successfully!") {
              currentComponent.setState({ modalIsOpen: false });
              currentComponent.setState({ modalIsOpenScheule : true });
            } else {
              toast({
                type: "warning",
                title: i18n.t("warning.label"),
                description: response.data.status,
                animation: "bounce",
                time: 5000
              });
            }
          }
        } else if (response.status === 204) {
          console.log("Something wrong");
          toast({
            type: 'error',
            title: i18n.t('error.label'),
            description:i18n.t('Something_wrong.label'),
            animation: 'bounce',
            time: 5000,

        });
        } 
      })
      .catch(function(error) {
        console.log(error);
        toast({
          type: 'error',
          title: i18n.t('error.label'),
          description:i18n.t('Something_wrong.label'),
          animation: 'bounce',
          time: 5000,

      });
      });
  };
  handleChangeMobile = value => {

     document.querySelector('.react-tel-input input[type=tel]').style='border-color:#ced4da';
    mobile = value;
    this.setState({ mobile: mobile });
    reactLocalStorage.set("mobile", mobile);
    
  };
  addNumber = event => {
   
    var mobiles = event.target.id;
    var newArray = mobile;
    if (newArray.includes(mobiles) === false) {
      newArray.push(event.target.id);
    } else {
      var index = newArray.indexOf(event.target.id);
      if (index != -1) {
        newArray.splice(index, 1);
      }
    }
    mobile = newArray;

    reactLocalStorage.set("mobiles", mobile);
  };

  onChangetemplate = event => {
    value_variables_one = this.state.content + " " + event.value;
    this.setState({ content: value_variables_one });
  };
  onChangegroup = event => {
    this.setState({ groups_id: event }, function() {});
  };
  onChangecategory = event => {
    this.setState({length_category:event.length})

    var i;
    var category;
    for (i = 0; i < event.length; i++) {
      category = event[i].label;

      var token = reactLocalStorage.get("accessToken");
      var ip = API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      if (ip.includes(s2)) {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/contacts/findAllCategoriesWithGroups";
      } else {
        apiBaseUrl =
          API_BASE_URL +
          "/core/user/rest/contacts/findAllCategoriesWithGroups";
      }

      var headers = { "Content-Type": "application/json", token: token };
      axios.get(apiBaseUrl, { headers: headers }).then(res => {
        if (res.data != undefined) {
          const dataoption = res.data.result.CategoriesWithGroups;

          var result = dataoption[category];
          var i;

          for (i = 0; i < result.length; i++) {
            array_data.push({
              label: result[i].group_name,
              value: result[i].id
            });
          }
          categoryGroupOptions = array_data;

          var value = this.state.title;
          this.setState({ title: value });
        }
      });
    }
  };

  handlePaginationChange = (e, { activePage }) => {
    this.setState({ activePage });
    var token = reactLocalStorage.get("accessToken");
    reactLocalStorage.get("user_id_login");
    var contactspagenumber = 0;
    contactspagenumber = activePage - 1;
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/contacts/user=" +
        reactLocalStorage.get("user_id_login") +
        "/page=" +
        contactspagenumber +
        "/findallcontacts";
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/contacts/user=" +
        reactLocalStorage.get("user_id_login") +
        "/page=" +
        contactspagenumber +
        "/findallcontacts";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then(res => {
      const persons = res.data.result.contacts;
      var totalContactspages = res.data.result.total_contacts / 20;
      this.setState({ totalpage: totalContactspages });
      if (res.data.result.contacts != undefined) {
        this.setState({ persons });
      }
    });
  };

  handleInputChange(evt) {
    this.setState({ input: evt.target.value });
  }

  handleInputKeyDown(evt) {
    if (evt.keyCode === 13 || this.state.input.length == 12 ) {
      const { value } = evt.target;

      this.setState(state => ({
        items: [...state.items, value],
        input: ""
      }));
    }

    if (
      this.state.items.length &&
      evt.keyCode === 8 &&
      !this.state.input.length
    ) {
      this.setState(state => ({
        items: state.items.slice(0, state.items.length - 1)
      }));
    }
  }

  handleRemoveItem(index) {
    
    return () => {
      this.setState(state => ({
        items: state.items.filter((item, i) => i != index)
      }));
    };
  }

  handleInputChange2(evt) {
    this.setState({ input2: evt.target.value });
 
  }

  handleInputKeyDown2(evt) {
    if (evt.keyCode === 13 || this.state.input2.length == 12 ) {
      const { value } = evt.target;

      this.setState(state => ({
        items2: [...state.items2, value],
        input2: ""
      }));
    }

    if (
      this.state.items2.length &&
      evt.keyCode === 8 &&
      !this.state.input2.length
    ) {
     
      this.setState(state => ({
        items2: state.items2.slice(0, state.items2.length - 1)
      }));
    }
  }

  handleRemoveItem2(index) {
    return () => {
      this.setState(state => ({
        items2: state.items2.filter((item, i) => i != index)
      }));
    };
  }
  onChangecategoryGroup = event => {
    category_ids = event;
  };
  viewcategoryGroupOptions = () => {
    if (categoryGroupOptions != []) {
      return categoryGroupOptions;
    }
  };
  componentDidMount() {

    var lang = i18n.language;

    if (lang === "ar") {
      this.setState({ isArabic: true });
      document.querySelector(".yellow_color").style =
        "float:right;margin-right: 15%;white-space: pre;";
      document.querySelector(".Logo_auth").style = "float:left;";
      document.querySelector(".bulk_add_card").style =
        "text-align: right;float:left;";
      document.querySelector(".btn_eng").style = "display:none;";
      document.querySelector(".btn_ar").style = "display:block;";
      document.querySelector(".btn_eng_step2").style = "display:none;";
      document.querySelector(".btn_ar_step2").style = "display:block;";
      document.querySelector(".btn_eng_step3").style = "display:none;";
      document.querySelector(".btn_ar_step3").style = "display:block;";
    } else {
      document.querySelector(".Logo_auth").style = "float:right;";
    }
  }
  addVariables = () =>
  {
    var content_data=this.state.content;
    var new_data=''
    if(content_data.length > 0)
    {
        if(content_data.includes('var_')) 
        {
          count=count+1;
        
        new_data=content_data +' '+'{var_'+count+'}';
        this.setState({content:new_data});
        }
        else
        {
          new_data=content_data +' '+'{var_'+count+'}';
          this.setState({content:new_data});
        }
    }
  }
  render() {
    const { activePage } = this.state;
    const { activeIndex } = this.state;
    const styles = {
      container: {
        border: "1px solid #ddd",
        padding: "5px",
        borderRadius: "5px"
      },

      items: {
        display: "inline-block",
        padding: "2px",
        border: "1px solid blue",
        fontFamily: "Helvetica, sans-serif",
        borderRadius: "5px",
        marginRight: "5px",
        cursor: "pointer"
      },

      input: {
        outline: "none",
        border: "none",
        fontSize: "14px",
        fontFamily: "Helvetica, sans-serif",
        width: " 520px !important"
      },
      items2: {
        display: "inline-block",
        padding: "2px",
        border: "1px solid blue",
        fontFamily: "Helvetica, sans-serif",
        borderRadius: "5px",
        marginRight: "5px",
        cursor: "pointer"
      },

      input2: {
        outline: "none",
        border: "none",
        fontSize: "14px",
        fontFamily: "Helvetica, sans-serif",
        width: " 520px !important"
      }
    };

 

    return (
      <div className="big_div">
        <Menutest />
        <div className="actionMenu">
          <div className="main_div_sms">
            <div className="sms_main">
              <Grid columns={2} divided>
                <Grid.Row stretched>
                  <Grid.Column className="grid_logo">
                    <Segment>
                      <h3 className="text_style yellow_color">Bulk SMS  </h3>
                    </Segment>
                  </Grid.Column>

                  <Grid.Column
                    className="grid_language"
                    style={{ width: "44%" }}
                  >
                    <Segment>
                      <Link to="/app/ReportBulk">
                        <img
                          src={require("../pictures/report.png")}
                          className="Logo_auth"
                          alt="logo"
                          data-tip={i18n.t("view_report.label")}
                        />
                      </Link>
                     
                      
                    </Segment>
              
                  </Grid.Column>
                </Grid.Row>
             
              </Grid>
              <hr />
           
              <Modal
                isOpen={this.state.modalIsOpenScheule}
                onAfterOpen={this.afterOpenModalSchedule}
                onRequestClose={this.closeModalSchedule}
                style={customStylesstop}
                contentLabel="Example Modal"
                className="stop_modal"
              >
                <i
                  class="close icon"
                  onClick={this.closeModalSchedule}
                  style={{ float: this.state.isArabic ? "left" : "" }}
                />
                <h2
                  ref={subtitle => (this.subtitle = subtitle)}
                  className="report_title_schedule"
                  style={{
                    textAlign: this.state.isArabic ? "right" : "",
                    marginRight: this.state.isArabic ? "2%" : "",

                  }}
                >
                  {i18n.t("Job_scheduling.label")}
                </h2>
                <div>
                  <Button
                    onClick={this.closeModalSchedule}
                    className="jobb_schedule"
                  >
                    {i18n.t("OK.label")}
                  </Button>

                </div>
                <br />
              </Modal>

              
              <div className="bulk_add_card">
                <div className="profile_data">
                  <h2 className="text_center yellow_color">
                    {i18n.t("Step_One.label")}
                  </h2>

                  <br />
                  <label
                    htmlFor="defaultFormCardNameEx"
                    className="grey-text font-weight-light"
                  >
                    {i18n.t("Title.label")}
                  </label>
                  <input
                    required="required"
                    type="text"
                    id="defaultFormCardNameEx"
                    className="form-control title_data"
                    value={this.state.title}
                    name="name"
                    onChange={this.handleChangeTitle}
                  />
                  <br />

                  <br />
                  <p className="h6 black_color">
                    {i18n.t("Recipient_numbers_type.label")}
                  </p>
                  <Select
                    fluid
                    search
                    selection
                    value={this.state.typeofMSg}
                    className="select_data"
                    placeholder={this.state.nameoftype}
                    options={this.state.products}
                    onChange={this.onChange.bind(this)}
                    id="dropselect"
                  />

                  <br />
                  <div className="mobile_div" style={{ display: "none" }}>
                    <label
                      htmlFor="defaultFormCardNameEx"
                      className="grey-text font-weight-light"
                    >
                      {i18n.t("Mobile_Number.label")}
                    </label>
              
                <PhoneInput required="required"   className="form-control moile_data" defaultCountry={'jo'} onChange={this.handleChangeMobile} value={this.state.mobile}  excludeCountries={["il"]}
                onlyCountries={["jo"]}/>

                    <br />
                    <br />
                  </div>

                  <div className="upload_div" style={{ display: "none" }}>
                    <label
                      htmlFor="defaultFormCardNameEx"
                      className="grey-text font-weight-light"
                    >
                      {i18n.t("Upload_file.label")}
                    </label>
                    <input
                      type="file"
                      id="defaultFormCardNameEx"
                      className="form-control input_file"
                      name="mobile"
                      required="required"
                      onChange={this.handleChangeupload}
                      key={this.state.inputKey}
                    />

                    <br />
                    <br />
                  </div>

                  <div className="group_div" style={{ display: "none" }}>
                    <p>{i18n.t("Groups.label")}</p>
                    <Select
                      placeholder={i18n.t("select.label")}
                      fluid
                      isMulti
                      search
                      selection
                      options={groupOptions}
                      onChange={this.onChangegroup.bind(this)}
                      className='group_input'
                      key={this.state.inputKey}
                    />
                    <br />
                    <label>
                      {i18n.t("add_numbers.label")}
                      <ul style={styles.container}>
                        {this.state.items.map((item, i) => (
                          <li
                            key={i}
                            style={styles.items}
                            onClick={this.handleRemoveItem(i)}
                          >
                            {item}
                            <span>(x)</span>
                          </li>
                        ))}
                        <input
                          style={styles.input}
                          value={this.state.input}
                          onChange={this.handleInputChange}
                          onKeyUp={this.handleInputKeyDown}
                          className="add_number"
                        />

                      </ul>
                    </label>
                    <br />

                    <label>
                      {i18n.t("remove_numbers.label")}
                      <ul style={styles.container}>
                        {this.state.items2.map((item, i) => (
                          <li
                            key={i}
                            style={styles.items2}
                            onClick={this.handleRemoveItem2(i)}
                          >
                            {item}
                            <span>(x)</span>
                          </li>
                        ))}
                        <input
                          style={styles.input2}
                          value={this.state.input2}
                          onChange={this.handleInputChange2}
                          onKeyUp={this.handleInputKeyDown2}
                          className="add_number"
                        />
                      </ul>
                    </label>
                  </div>
                  <div className="category_div" style={{ display: "none" }}>
                    <Select
                      placeholder={i18n.t("select.label")}
                      fluid
                      isMulti
                      search
                      selection
                      options={categoryOptions}
                      onChange={this.onChangecategory.bind(this)}
                      className='category_input'
                      key={this.state.inputKey}
                    />
                    <br />

                    <div className="append_data">
                      <Select
                        placeholder={i18n.t("Select_group.label")}
                        fluid
                        isMulti
                        search
                        selection
                        options={
                          categoryGroupOptions
                            ? this.viewcategoryGroupOptions()
                            : ""
                        }
                        onChange={this.onChangecategoryGroup.bind(this)}
                        className="categoryGroup"
                        style={{ display: "none" }}
                      />
                      <br />
                    </div>
                  </div>

                  <div className="contact_list_div" style={{ display: "none" }}>
                    <Modal
                      isOpen={this.state.modalIsOpenContact}
                      onAfterOpen={this.afterOpenModalContact}
                      onRequestClose={this.closemodalcontact}
                      style={customStyles}
                      contentLabel="Example Modal"
                      className="modal_contact"
                    >
                      <i
                        class="close icon close_modal"
                        onClick={this.closemodalcontact}
                      />
                      <h2
                        ref={subtitle => (this.subtitle = subtitle)}
                        className="report_titles"
                      >
                        {i18n.t("Contact_List.label")}
                      </h2>
                      <hr />
                      <div className="">
                        <input
                          placeholder="Search for..."
                          onChange={this.searchchange.bind(this)}
                          className="search_web_contact search_list"
                          style={{ padding: "3px", marginTop: "1%" }}
                        />
                        <br /> <br />
                        <div className="container_cards view_basic">
                          {this.state.persons.map(person => (
                            <List divided verticalAlign="middle">
                              <List.Item
                                className="en_list"
                                key={person.display}
                              >
                                <div
                                  style={{
                                    width: "100%",
                                    display: "-webkit-box"
                                  }}
                                >
                                  <Checkbox
                                    label=""
                                    style={{ width: "20%" }}
                                    onClick={this.addNumber}
                                    id={person.mobile_number}
                                  />
                                  <List.Content style={{ width: "80%" }}>
                                    {person.first_name} {person.second_name}{" "}
                                    {person.family_name}
                                  </List.Content>
                                </div>
                                <List.Content className="mobile_content">
                                  {person.mobile_number}
                                </List.Content>

                                <List.Content>
                                  <Accordion>
                                    <Accordion.Title
                                      active={activeIndex === person.id}
                                      index={person.id}
                                      onClick={this.handleClick}
                                      className="view_sub"
                                    >
                                      <Icon name="dropdown" />

                                      {i18n.t("View_Contact.label")}
                                    </Accordion.Title>
                                    <Accordion.Content
                                      active={activeIndex === person.id}
                                    >
                                      <Table celled>
                                        <Table.Header>
                                          <Table.Row>
                                            <Table.HeaderCell>
                                              {" "}
                                              {i18n.t("Full_Name.label")}
                                            </Table.HeaderCell>
                                            <Table.HeaderCell>
                                              {i18n.t("Mobile_Number.label")}
                                            </Table.HeaderCell>
                                            <Table.HeaderCell>
                                              {i18n.t("company.label")}
                                            </Table.HeaderCell>
                                          </Table.Row>
                                        </Table.Header>

                                        <Table.Body>
                                          <Table.Row>
                                            <Table.Cell>
                                              {person.first_name}{" "}
                                              {person.second_name}{" "}
                                              {person.family_name}
                                            </Table.Cell>
                                            <Table.Cell>
                                              {person.mobile_number}
                                            </Table.Cell>
                                            <Table.Cell>
                                              {person.company}
                                            </Table.Cell>
                                          </Table.Row>
                                        </Table.Body>
                                      </Table>
                                    </Accordion.Content>
                                  </Accordion>
                                </List.Content>
                              </List.Item>

                              <List.Item
                                className="ar_list"
                                style={{ display: "none" }}
                              >
                                <div
                                  style={{
                                    width: "100%",
                                    display: "-webkit-box"
                                  }}
                                >
                                  <Checkbox
                                    label=""
                                    style={{ width: "20%" }}
                                    onClick={this.addNumber}
                                    id={person.id}
                                  />
                                  <List.Content
                                    style={{ width: "80%", float: "right" }}
                                  >
                                    {person.first_name} {person.second_name}{" "}
                                    {person.family_name}
                                  </List.Content>
                                </div>
                                <List.Content
                                  className="mobile_content"
                                  style={{ textAlign: "right" }}
                                >
                                  {person.mobile_number}
                                </List.Content>

                                <List.Content>
                                  <Accordion>
                                    <Accordion.Title
                                      active={activeIndex === person.id}
                                      index={person.id}
                                      onClick={this.handleClick}
                                      className="view_sub"
                                    >
                                      <Icon name="dropdown" />

                                      {i18n.t("View_Contact.label")}
                                    </Accordion.Title>
                                    <Accordion.Content
                                      active={activeIndex === person.id}
                                    >
                                      <Table celled>
                                        <Table.Header>
                                          <Table.Row>
                                            <Table.HeaderCell>
                                              {" "}
                                              {i18n.t("Full_Name.label")}
                                            </Table.HeaderCell>
                                            <Table.HeaderCell>
                                              {i18n.t("Mobile_Number.label")}
                                            </Table.HeaderCell>
                                            <Table.HeaderCell>
                                              {i18n.t("company.label")}
                                            </Table.HeaderCell>
                                          </Table.Row>
                                        </Table.Header>

                                        <Table.Body>
                                          <Table.Row>
                                            <Table.Cell>
                                              {person.first_name}{" "}
                                              {person.second_name}{" "}
                                              {person.family_name}
                                            </Table.Cell>
                                            <Table.Cell>
                                              {person.mobile_number}
                                            </Table.Cell>
                                            <Table.Cell>
                                              {person.company}
                                            </Table.Cell>
                                          </Table.Row>
                                        </Table.Body>
                                      </Table>
                                    </Accordion.Content>
                                  </Accordion>
                                </List.Content>
                              </List.Item>
                            </List>
                          ))}
                         
                        </div>
                        <div
                          className="container_cards view_search"
                          style={{ display: "none" }}
                        >
                          {this.state.personssearch.map(person => (
                            <List divided verticalAlign="middle">
                              <List.Item className="en_list">
                                <div
                                  style={{
                                    width: "100%",
                                    display: "-webkit-box"
                                  }}
                                >
                                  <Checkbox
                                    label=""
                                    style={{ width: "20%" }}
                                    onClick={this.addNumber}
                                    id={person.id}
                                  />
                                  <List.Content style={{ width: "80%" }}>
                                    {person.first_name} {person.second_name}{" "}
                                    {person.family_name}
                                  </List.Content>
                                </div>
                                <List.Content className="mobile_content">
                                  {person.mobile_number}
                                </List.Content>
                                <List.Content>
                                  <Accordion>
                                    <Accordion.Title
                                      active={activeIndex === person.id}
                                      index={person.id}
                                      onClick={this.handleClick}
                                      className="view_sub"
                                    >
                                      <Icon name="dropdown" />

                                      {i18n.t("View_Contact.label")}
                                    </Accordion.Title>
                                    <Accordion.Content
                                      active={activeIndex === person.id}
                                    >
                                      <Table celled>
                                        <Table.Header>
                                          <Table.Row>
                                            <Table.HeaderCell>
                                              {" "}
                                              {i18n.t("Full_Name.label")}
                                            </Table.HeaderCell>
                                            <Table.HeaderCell>
                                              {i18n.t("Mobile_Number.label")}
                                            </Table.HeaderCell>
                                            <Table.HeaderCell>
                                              {i18n.t("company.label")}
                                            </Table.HeaderCell>
                                          </Table.Row>
                                        </Table.Header>

                                        <Table.Body>
                                          <Table.Row>
                                            <Table.Cell>
                                              {person.first_name}{" "}
                                              {person.second_name}{" "}
                                              {person.family_name}
                                            </Table.Cell>
                                            <Table.Cell>
                                              {person.mobile_number}
                                            </Table.Cell>
                                            <Table.Cell>
                                              {person.company}
                                            </Table.Cell>
                                          </Table.Row>
                                        </Table.Body>
                                      </Table>
                                    </Accordion.Content>
                                  </Accordion>
                                </List.Content>
                              </List.Item>

                              <List.Item
                                className="ar_list"
                                style={{ display: "none" }}
                              >
                                <div
                                  style={{
                                    width: "100%",
                                    display: "-webkit-box"
                                  }}
                                >
                                  <Checkbox
                                    label=""
                                    style={{ width: "20%" }}
                                    onClick={this.addNumber}
                                    id={person.id}
                                  />
                                  <List.Content
                                    style={{ width: "80%", float: "right" }}
                                  >
                                    {person.first_name} {person.second_name}{" "}
                                    {person.family_name}
                                  </List.Content>
                                </div>
                                <List.Content
                                  className="mobile_content"
                                  style={{ textAlign: "right" }}
                                >
                                  {person.mobile_number}
                                </List.Content>
                              </List.Item>
                            </List>
                          ))}
                        </div>
                        <Pagination
                          defaultActivePage={1}
                          activePage={activePage}
                          onPageChange={this.handlePaginationChange}
                          onClick={this.viewdata}
                          totalPages={this.state.totalpage}
                          className="page_contact"
                        />
                     
                      </div>
                      <Button style={{marginTop: '8%',float: 'right',marginRight: '-18.5%'}} onClick={this.closemodalcontact}>Submit</Button>
                    </Modal>

                    <br />
                    <br />
                  </div>

                  <div className="btn_eng">
                    <Button
                      content={i18n.t("Next.label")}
                      icon="right arrow"
                      labelPosition="right"
                      onClick={this.openstep2}
                      className="next_btn"
                      style={{ color: "white" }}
                    />
                  </div>

                  <div className="btn_ar" style={{ display: "none" }}>
                    <Button
                      content={i18n.t("Next.label")}
                      icon="left arrow"
                      labelPosition="left"
                      onClick={this.openstep2}
                      className="previous_btn"
                      style={{ color: "white" }}
                    />
                  </div>
                </div>
              </div>

              <div className="step_two" style={{ display: "none" }}>
                <h2 className="text_center yellow_color">
                  {i18n.t("Step_Two.label")}
                </h2>
                <label
                  htmlFor="defaultFormCardNameEx"
                  className="grey-text font-weight-light"
                >
                  {i18n.t("Sender_ID.label")}
                </label>
                <Select
                  placeholder={i18n.t("select.label")}
                  fluid
                  search
                  selection
                  options={countryOptions}
                  value={this.state.senderidselect}
                  placeholder={this.state.senderidselect}
                  onChange={this.onChangesenderid.bind(this)}
                  className="sender_value"
                />
                <br />
                <br /> <br />
                <div className="btn_eng_step2">
                  <Button
                    content={i18n.t("Previous.label")}
                    icon="left arrow"
                    labelPosition="left"
                    onClick={this.openstep1}
                    className="previous_btn"
                    style={{ color: "white" }}
                  />

                  <Button
                    content={i18n.t("Next.label")}
                    icon="right arrow"
                    labelPosition="right"
                    onClick={this.openstep3}
                    className="next_btn"
                    style={{ color: "white" }}
                  />
                </div>
                <div className="btn_ar_step2" style={{ display: "none" }}>
                  <Button
                    content={i18n.t("Previous.label")}
                    icon="right arrow"
                    labelPosition="right"
                    onClick={this.openstep1}
                    className="next_btn"
                    style={{ color: "white" }}
                  />

                  <Button
                    content={i18n.t("Next.label")}
                    icon="left arrow"
                    labelPosition="left"
                    onClick={this.openstep3}
                    className="previous_btn"
                    style={{ color: "white" }}
                  />
                </div>
              </div>

              <div className="step_three" style={{ display: "none" }}>
                <h2 className="text_center yellow_color">
                  {i18n.t("Step_Three.label")}
                </h2>
                <label
                  htmlFor="defaultFormCardNameEx"
                  className="grey-text font-weight-light"
                >
                  {i18n.t("Select_Time.label")}
                </label>
                <Select
                  options={this.state.time}
                  onChange={this.onChangetime.bind(this)}
                  defaultValue={this.state.timeselect}
                  placeholder={this.state.timeselect}
                />
                <br />
                <br />
                <span
                  className="templates-class"
                  style={{
                    display:
                      this.state.typeofMSg === "dynamic_file"
                        ? "none "
                        : "block"
                  }}
                >
                  <p>{i18n.t("Template.label")}</p>

                  <Select
                    placeholder={i18n.t("select.label")}
                    fluid
                    search
                    selection
                    options={template}
                    onChange={this.onChangetemplate.bind(this)}
                  />
                </span>
                <br />
                <div className="time_div" style={{ display: "none" }}>
                  <label
                    htmlFor="defaultFormCardNameEx"
                    className="grey-text font-weight-light"
                  >
                    {i18n.t("Time.label")}
                  </label>
                  <DateTime
                    onChange={this.onChangedatetime}
                    value={this.state.date}
                    className="test"
                    closeOnSelect={true}
                    closeOnTab={true}
                    locale={i18n.language}
                    isValidDate={ valid }
                  />

                  {/* <DateTimePicker
                    onChange={this.onChangedatetime}
                    value={this.state.date}
                    firstDayOfWeek={1}
                  /> */}
                  <br />
                  <br />
                </div>
                <span
                  style={{
                    display:
                      this.state.typeofMSg === "dynamic_file"
                        ? "none "
                        : "block"
                  }}
                >
                  <label
                    htmlFor="defaultFormCardNameEx"
                    className="grey-text font-weight-light content_label templates-class"
                  >
                    {i18n.t("Content.label")}
                  </label>
                  <Button className='add_variable_btn' style={{display:'none'}} onClick={this.addVariables}>{i18n.t("Add_variables.label")}</Button>
                  <textarea
                    className="form-control templates-class textarea_content"
                    id="exampleFormControlTextarea1"
                    name="mobile"
                    required="required"
                    onChange={this.handleChangeContent}
                    value={this.state.content}
                  />

                  <span
                    class="textarea__countar"
                    style={{ float: "right", display: "none" }}
                  >
                    {this.state.content.length}/
                    {Math.ceil(this.state.content.length / 70)}
                  </span>
                  <span class="textarea__countar_varaibles"  style={{ float: "right", display: "none" }}>
                  {i18n.t("count_variable.label")} :
                    {count}
                  </span>

                  <span class="textarea__counten" style={{ float: "right" }}>
                    {this.state.content.length}/
                    {Math.ceil(this.state.content.length / 160)}
                  </span>

                  <span class="textarea__counten_varaibles" style={{ float: "left" ,display:'none'}}>
                  {i18n.t("count_variable.label")} :
                    {count}
                  </span>

                </span>
                <br /> <br />
                <div style={{ display: "none" }} className="drop_variables">
                  <label
                    htmlFor="defaultFormCardNameEx"
                    className="grey-text font-weight-light content_label"
                  >
                    {i18n.t("choose_variables.label")}
                  </label>
                  <Select
                    style={{ display: "none" }}
                    options={this.state.variables}
                    onChange={this.onChangevariables.bind(this)}
                    defaultValue={this.state.typeofvariable}
                    placeholder={this.state.nameofvariable}
                  />
                </div>
                <br />
                <div className="btn_eng_step3">
                  <Button
                    content={i18n.t("Previous.label")}
                    icon="left arrow"
                    labelPosition="left"
                    onClick={this.openstep22}
                    className="previous_btn"
                    style={{ color: "white" }}
                    id='btn_back_step3'
                  />
                  <Button
                  id="btn_submit_step3"
                    content={i18n.t("Submit.label")}
                    icon="right arrow"
                    labelPosition="right"
                    onClick={this.submit}
                    className="next_btn"
                    style={{ color: "white" }}
                  />
                </div>
                <div className="btn_ar_step3" style={{ display: "none" }}>
                  <Button
                  id="btn_submit_step3"
                    content={i18n.t("Submit.label")}
                    icon="left arrow"
                    labelPosition="left"
                    onClick={this.submit}
                    className="prevoius_btn"
                    style={{
                      color: "white",
                      backgroundColor: "#fac810",
                      float: "left"
                    }}
                  />
                  <Button
                    content={i18n.t("Previous.label")}
                    icon="right arrow"
                    labelPosition="right"
                    onClick={this.openstep22}
                    className="next_btn"
                    id='btn_back_step3'
                    style={{ color: "white" }}
                  />
                </div>
              </div>
              <div className="modal_ads">
                <Modal
                  isOpen={this.state.modalIsOpen}
                  onAfterOpen={this.afterOpenModal}
                  onRequestClose={this.closeModal}
                  style={customStyles}
                  contentLabel="Example Modal"
                >
                  <i class="close icon close_modal" onClick={this.closeModal} />

                  <h2 ref={subtitle => (this.subtitle = subtitle)} />
                  <br />
                  <div className="">
                    <div
                      style={{ direction: this.state.isArabic ? "rtl" : "" }}
                    >
                      <Table celled inverted selectable>
                        <Table.Header>
                          <Table.Row>
                            <Table.HeaderCell
                              style={{
                                width: "26.3%",
                                textAlign: this.state.isArabic ? "right" : ""
                              }}
                            >
                              {i18n.t("totalmsg.label")}
                            </Table.HeaderCell>

                            <Table.Cell
                              style={{
                                textAlign: this.state.isArabic ? "right" : ""
                              }}
                            >
                              {this.state.totalmsg}
                            </Table.Cell>
                          </Table.Row>
                          <Table.Row>
                            <Table.HeaderCell
                              style={{
                                width: "26.3%",
                                textAlign: this.state.isArabic ? "right" : ""
                              }}
                            >
                              {i18n.t("totalValid_Number.label")}
                            </Table.HeaderCell>

                            <Table.Cell
                              style={{
                                textAlign: this.state.isArabic ? "right" : ""
                              }}
                            >
                              {this.state.resultall}
                            </Table.Cell>
                          </Table.Row>
                          <Table.Row>
                            <Table.HeaderCell
                              style={{
                                width: "26.3%",
                                textAlign: this.state.isArabic ? "right" : ""
                              }}
                            >
                              {i18n.t("totalinValid_Number.label")}
                            </Table.HeaderCell>

                            <Table.Cell
                              style={{
                                textAlign: this.state.isArabic ? "right" : ""
                              }}
                            >
                              {this.state.resultallinvalid}
                            </Table.Cell>
                          </Table.Row>
                          <Table.Row>
                            <Table.HeaderCell
                              style={{
                                width: "26.3%",
                                textAlign: this.state.isArabic ? "right" : ""
                              }}
                            >
                              {i18n.t("balance_reserved.label")}
                            </Table.HeaderCell>

                            <Table.Cell
                              style={{
                                textAlign: this.state.isArabic ? "right" : ""
                              }}
                            >
                              {this.state.balance_reserved}
                            </Table.Cell>
                          </Table.Row>
                        </Table.Header>

                        <Table.Body>
                          <Table.Row />
                        </Table.Body>
                      </Table>
                    </div>
                  </div>
                  <Button onClick={this.confirm_msg} className="close_report confirm_sms" id="confirm_sms">
                    {i18n.t("Confirm.label")}
                  </Button>
                  <Button onClick={this.closeModal} className="close_report">
                    {i18n.t("Close.label")}
                  </Button>
                </Modal>

              </div>

            </div>
            <SemanticToastContainer />
            <div className="animation_style" style={{ display: "none" }}>
              <Confetti style={{ height: "-webkit-fill-available" }} />
            </div>

          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return { ...state };
};
export default connect(mapStateToProps)(BulkSMS);